import { lazy } from 'react';

const Settings = lazy(() =>  import('../pages/Settings'));
const SettingsInfo = lazy(() =>  import('../pages/Settings/Info'));
const BillingProfileList = lazy(() =>  import('../pages/Settings/BillingProfiles/List'));
const BillingProfileDetail = lazy(() =>  import('../pages/Settings/BillingProfiles/Detail'));
// const ContactsList = lazy(() =>  import('../pages/Settings/Contacts/List'));
// const ContactsDetail = lazy(() =>  import('../pages/Settings/Contacts/Detail'));

export default [{
    path: "/settings",
    element: Settings,
    analytics: { name: ["Impostazioni"]}
},{
    path: "/settings/info",
    element: SettingsInfo,
    analytics: { name: ["Impostazioni", "Informazioni"]},
}, {
    path: "/settings/billingprofiles",
    element: BillingProfileList,
    analytics: { name: ["Impostazioni", "Profili di fatturazione"]},
}, {
    path: "/settings/billingprofiles/:billingprofileId",
    element: BillingProfileDetail,
    analytics: { name: ["Impostazioni", "Profili di fatturazione", "Dettaglio"]},
// }, {
//     path: "/settings/contacts",
//     element: ContactsList,
//     analytics: { name: ["Agenzie", "Impostazioni", "Contatti"]},
// }, {
//     path: "/settings/contacts/:contactId",
//     element: ContactsDetail,
//     analytics: { name: ["Agenzie", "Impostazioni", "Contatti", "Dettaglio"]},
}]
